import { AxiosError } from "axios";
import { useGlobalMessagesStore } from "./globalMessagesStore";
import { ref } from "vue";

export function handleError(error: AxiosError | any) {
    const globalMessages = useGlobalMessagesStore();
    if (error.isAxiosError) {
        const response = (error as AxiosError).response;
        if (response == null) {
            globalMessages.push({ message: "An error occurred. Please check network connectivity.", type: "error" })

            return;
        }
    }
    console.error(error);
    globalMessages.push({ message: error, type: "error" })
}

export function useInitializeStore(apiCall) {
    const initialized = ref(false);
    const loading = ref(false);

    (async function () {
        loading.value = true;
        await apiCall();
        initialized.value = true;
        loading.value = false;
    })();

    return { initialized, loading };
}